export default "__VITE_ASSET__Bxls_Ss$__"